import React from 'react';
import { Button } from 'primereact/button';

interface CompletionStepProps {
  created: number;
  skipped: number;
  totalAmount: number;
  onDone: () => void;
}

export const CompletionStep: React.FC<CompletionStepProps> = ({
  created,
  skipped,
  totalAmount,
  onDone,
}) => {
  const formatCurrency = (amount: number) =>
    new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(amount);

  return (
    <div data-component="bank-import-completion-step" style={{ display: 'block', textAlign: 'center', padding: '2rem' }}>
      <div style={{ display: 'block', maxWidth: '400px', margin: '0 auto' }}>
        <i className="pi pi-check-circle" style={{ fontSize: '3rem', color: '#22c55e', display: 'block', marginBottom: '1rem' }} />
        <h3 style={{ margin: '0 0 1.5rem 0' }}>Import Complete</h3>

        <div style={{ background: 'var(--surface-100)', borderRadius: '6px', padding: '1rem', marginBottom: '1.5rem', textAlign: 'left' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
            <span style={{ color: 'var(--text-color-secondary)' }}>Payments Created</span>
            <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{created}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.75rem' }}>
            <span style={{ color: 'var(--text-color-secondary)' }}>Total Amount</span>
            <span style={{ fontWeight: 'bold', fontSize: '1.1rem', color: '#22c55e' }}>{formatCurrency(totalAmount)}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span style={{ color: 'var(--text-color-secondary)' }}>Rows Skipped</span>
            <span style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{skipped}</span>
          </div>
        </div>

        <Button
          label="Done"
          icon="pi pi-check"
          onClick={onDone}
          size="large"
        />
      </div>
    </div>
  );
};
